import React from 'react'

import ALL_SET_IMAGE from '@public/assets/welcome-wizard/setup-complete.png'

const FinishStep = () => (
  <div className="max-w-[900px]">
    <h2 className="text-lg font-semibold text-black">You&apos;re All Set 🎉</h2>
    <p className="mt-4 text-base leading-[1.35] text-[#666]">
      MIRA is now working to capture billable work from your daily activities.
      <br />
      We&apos;d like to quickly guide you through how to use MIRA. Activities
      are captured throughout the day, and we encourage you to review them daily
      by the end of the day. It takes just a couple of minutes. The more you use
      it, the better results it will provide for matter mapping and grouping.
    </p>
    <ul className="mt-1 list-disc pl-5 text-base leading-[1.35] text-[#666]">
      <li>Review captured activities from Timeline Panel</li>
      <li>Quick tips about Time Entry panel</li>
      <li>Push activities to your billing system</li>
    </ul>
    <img
      alt="User celebrating setup completion"
      className="ml-auto mt-5 h-[250px] w-[450px] object-contain"
      src={ALL_SET_IMAGE}
    />
  </div>
)

export default FinishStep
